export const GOOGLE_API_KEY = "AIzaSyBc6gKK5bf-wbQoG8VWjSyhrPCppv5T4HM";

export const findLocations = (address, callback) => {
    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${GOOGLE_API_KEY}`;
    fetch(url)
        .then(response => response.json())
        .then(data => {
            if (data.results.length > 0) {
                // Extract latitude and longitude from the response
                const location = data.results[0].geometry.location;
                callback(location, data.results);
            } else {
                callback();
            }
        })
        .catch(error => {
            console.error("Error:", error);
            callback();
        });
};

export const viewLatLngUrl = (location, zoomLevel) => {
    const url = `https://www.google.com/maps/@${location.lat},${location.lng},${zoomLevel || 20}z`;
    return url;
};

export const getLocationAddress = (location, callback) => {
    const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${location.lat},${location.lng}&key=${GOOGLE_API_KEY}`;
    fetch(url)
        .then(response => response.json())
        .then(data => {
            if (data.results.length > 0) {
                callback(extractBestAddress(data.results));
            } else {
                callback();
            }
        })
        .catch(error => {
            console.error("Error:", error);
            callback();
        });
};

function extractBestAddress(results) {
    let bestAddress = '';
    let bestMatchScore = 0;

    results.forEach(result => {
        let street = '';
        let city = '';
        let postalCode = '';
        let matchScore = 0;

        result.address_components.forEach(component => {
            if (component.types.includes('street_number')) {
                street += component.long_name + ' ';
                matchScore++;
            }
            if (component.types.includes('route')) {
                street += component.long_name;
                matchScore++;
            }
            if (component.types.includes('locality')) {
                city = component.long_name;
                matchScore++;
            }
            if (component.types.includes('postal_code')) {
                postalCode = component.long_name;
                matchScore++;
            }
        });

        const address = `${street.trim()}, ${city}, ${postalCode}`.trim();
        if (matchScore > bestMatchScore) {
            bestAddress = address;
            bestMatchScore = matchScore;
        }
    });
    return bestAddress || undefined;
}